window.servicesVersionSecurityFixesEndCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        css: {
            "background-color": row.security_fixes_end_color
        }
    };
};
